export default __webpack_public_path__ + "static/wwc-image7-cbf9a4f54a835a113c1d094589c7d603.jpg";